import { ConfigType } from "../utils/requestAPI";

interface PaymentMethodPayload {
  title: string;
  key: string;
  icon: string;
  id?: string;
}

const paymentMethodApis = {
  getAllPaymentMethods: (): ConfigType => {
    return {
      method: "get",
      url: "payment-methods",
    };
  },
  deletePaymentMethodID: (id: string): ConfigType => {
    return {
      method: "delete",
      url: `payment-methods/${id}`,
    };
  },
  addEditPaymentMethod: (data: PaymentMethodPayload): ConfigType => {
    return {
      method: "post",
      url: "payment-methods",
      data,
    };
  },
};

export default paymentMethodApis;
